import { render, staticRenderFns } from "./feedbackDetails.vue?vue&type=template&id=1c017506&scoped=true&"
import script from "./feedbackDetails.vue?vue&type=script&lang=js&"
export * from "./feedbackDetails.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetails.vue?vue&type=style&index=0&id=1c017506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c017506",
  null
  
)

export default component.exports